var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3411 6.27165C30.0319 5.96153 29.5298 5.96153 29.2201 6.27165L6.88653 28.6057C6.57688 28.9149 6.57688 29.4175 6.88653 29.7271C7.04117 29.8818 7.24388 29.959 7.44701 29.959C7.64972 29.959 7.8529 29.8821 8.00749 29.7267L30.3411 7.39265C30.6508 7.08343 30.6508 6.58135 30.3411 6.27165Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6914 15.1985C14.8461 15.3536 15.0488 15.4309 15.2519 15.4309C15.4551 15.4309 15.6578 15.3536 15.8124 15.1985C16.122 14.8893 16.122 14.3872 15.8124 14.0775L6.78 5.04509C6.47077 4.73497 5.96869 4.73497 5.65899 5.04509C5.34935 5.35432 5.34935 5.8564 5.65899 6.16609L14.6914 15.1985Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2931 20.559C21.9834 20.2484 21.4818 20.2489 21.1721 20.5585C20.862 20.8682 20.862 21.3699 21.1717 21.6796L30.1401 30.6492C30.2956 30.8039 30.4979 30.8811 30.701 30.8811C30.9037 30.8811 31.1069 30.8042 31.2615 30.6497C31.5712 30.3404 31.5712 29.8379 31.2615 29.5282L22.2931 20.559Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.6b31e4c970074df5da7d90e7c444729f.svg";
export { ForwardRef as ReactComponent };